<div class="rewards-list-root">
  <app-filter-area 
    content 
    [chipContents]="chipContents" 
    [isGrayBlue]="true" 
    (selectedFilter)="getFilter($event)"
    (selectedOption)="getOption($event)"
    [isCarousel]="false">
  </app-filter-area>
  <div class="title">
    {{labels.rewards}}
  </div>
  <div
    *ngIf="rewardList.length || loading"
    class="reward-list"
    infinite-scroll
    [infiniteScrollDistance]="0.1"
    [scrollWindow]="false"
    [immediateCheck]="true"
    (scrolled)="pullRewards()">
    <ng-container *ngFor="let reward of rewardList; index as i">
      <app-reward-card-slim [reward]="reward" index="{{i}}"></app-reward-card-slim>
    </ng-container>
    <mat-spinner diameter="15" [ngClass]="{hidden: !loading}">
    </mat-spinner>
  </div>
  <app-icon-paragraph *ngIf="!rewardList.length && !loading"
                      icon="list_alt"
                      [title]="labels.notFound"
                      [paragraph]="labels.notFoundDescription">
  </app-icon-paragraph>
</div>
